<template>
  <table id="tabCluster">
    <tr>
      <td class="desc-title headTd">{{title}}</td>
      <td colspan="2">
        <select v-model.lazy="selected" @change="selectedValue()" class="form-control form-control-sm">
          <option value="-">-</option>
          <option value="PRA-SCL" v-if="prefix === inputs.sterownik.value || inputs.sterownik.value === ''">{{ $t("message.systemController") }}</option>
          <option value="other">{{ $t("message.otherDevice") }}</option>
        </select>
      </td>
    </tr>
    <template v-if="selected === 'PRA-SCL'">
      <tr>
        <td></td> <!-- <span v-if="ethernet === 0 || ethernet === '0'" class="info">min. 1</span> -->
        <td class="device-content">{{ $t("message.mpsActiveEthernet") }}</td>
        <td class="qty-content">
          <input type="number" class="form-control form-control-sm" min=1 max=5
          v-model.lazy="ethernet" @change="inputValue()" name="ethernet" @input="addEvent"/>
        </td>
      </tr>
    </template>
    <template v-if="selected === 'other'">
      <tr>
        <td></td> <!-- <span v-if="maxCurrent === 0 || maxCurrent === '0'" class="info">min. 1</span> -->
        <td class="device-content">{{ $t("message.maxCurrent") }}</td>
        <td class="qty-content">
          <input type="number" class="form-control form-control-sm" min=0 max=700
          v-model.lazy="maxCurrent" @change="inputValue()" name="maxCurrent" @input="addEvent"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="device-content">{{ $t("message.heightOtherDivice") }}</td>
        <td class="qty-content">
          <input type="number" class="form-control form-control-sm" min=0 max=10
          v-model.lazy="countU" @change="inputValue()" name="countU" @input="addEvent"/>
        </td>
      </tr>
    </template>
    <tr class="wiersz-pusty"></tr>
  </table>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../../mixins/app'

export default {
  name: 'Output24',
  mixins: [app],
  props: ['title', 'values', 'clear', 'prefix'],
  data () {
    return {
      selected: '-',
      ethernet: 0,
      maxCurrent: 0,
      countU: 0
    }
  },
  watch: {
    clearing (newValue, oldValue) {
      if (newValue === true) {
        this.selected = '-'
        this.ethernet = 0
        this.maxCurrent = 0
        this.countU = 0
      }
    },
    clear (newValue, oldValue) {
      if (newValue === true) {
        this.selected = '-'
        this.ethernet = 0
        this.maxCurrent = 0
        this.countU = 0
      }
    },
    values (newValue, oldValue) {
      if (newValue !== null) {
        this.selected = this.values.selected
        this.ethernet = this.values.ethernet
        this.maxCurrent = this.values.maxCurrent
        this.countU = this.values.countU
      }
    }
  },
  computed: {
    ...mapGetters('app', ['clearing']),
    ...mapGetters('app', ['clusters']),
    ...mapGetters('app', ['inputs'])
  },
  methods: {
    addEvent ({ type, target }) {
      if (target.max) {
        if (Number(target.max) < Number(target.value)) {
          target.value = target.max
          this[target.name] = target.max
        }
      }
    },
    selectedValue () {
      if (this.selected === 'PRA-SCL') {
        this.maxCurrent = 0
        this.ethernet = 1
        this.changeValueInputs('sterownik', 'value', this.prefix)
      } else if (this.selected === 'other') {
        this.ethernet = 0
        if (this.prefix === this.inputs.sterownik.value) {
          this.changeValueInputs('sterownik', 'value', '')
        }
      } else {
        this.ethernet = 0
        this.maxCurrent = 0
        this.countU = 0
        if (this.prefix === this.inputs.sterownik.value) {
          this.changeValueInputs('sterownik', 'value', '')
        }
      }
      this.$emit('allValues', this.selected, this.ethernet, this.maxCurrent, this.countU)
    },
    inputValue () {
      this.$emit('allValues', this.selected, this.ethernet, this.maxCurrent, this.countU)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Devices/Output24.vue